
<style>
.fixed-top-2 {
    background: #f3a42f;
}
.top__30
{
top: 28px;
}
.navbar-brand img {
    width: 100px !important;
    top: 4.5px !important;
}
.owl-radius
{
margin-left:3.5rem;
padding: 2px;
}
.ml_4
{
margin-left:4rem!important;
}
.navbar-nav>li.pays a::before
    {
        background-color:transparent !important
    }
</style>
<template>
 <header>
     <nav v-if="env!='live'" class="navbar navbar-toggleable-sm bg-faded navbar-light mx-auto fixed-top fixed-top-2">
      <span class="text-center mx-auto text-white">This is Sandbox / Test environment </span>
      <div class="navbar-collapse collapse" id="navbar1">
          <ul class="navbar-nav">

          </ul>
      </div>
    </nav>
    <nav class="navbar navbar-expand-lg navbar-dark nav-light fixed-top " :class="env=='live'?'':'top__30'">
        <div class="container-fluid">
            <a class="navbar-brand pointer-link mb-1">
                <img v-bind:src="cdnUrl"  width="220"  @click.prevent="logonav()">
                <!-- </img> -->
                <ul class="navbar-nav">
                     <li class="nav-item mt-1 ml_4 owl-radius" v-if="productList.length<=1"><span class="bld">{{activeModelName}}</span></li>
                    <li class="nav-item dropdown pays mt-1" v-if="productList.length > 1">
                        <a href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"  aria-haspopup="true" aria-expanded="false" class="nav-link dropdown-toggle owl-radius">
                            {{activeModelName}}
                        </a>
                        <div aria-labelledby="navbarDropdown" class="dropdown-menu">
                            <a  v-for="item in productList" class="dropdown-item pointer-link" @click.prevent="changeModel(item)">{{item.productName}}</a>

                        </div>
                    </li>
                    </ul>
            </a>
            <button class="navbar-toggler position-fixed top-0 end-0 mt-5 me-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar" aria-controls="collapsibleNavbar" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="collapsibleNavbar">
              <ul class="navbar-nav" v-if="activeModelCode=='CASH_COLLECT'">
                     <li class="nav-item"  v-if="isShow('0,1,2,3')" @click.prevent="setActive('transactions')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/cashcollect/transactions">Transactions</router-link>
                    </li>
                    <li class="nav-item"  v-if="isShow('0,1,2,3')" @click.prevent="setActive('customers')" :class="{ active: isActive('customers') }">
                        <router-link  class="nav-link" to="/cashcollect/customer-list">Customers</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                          <router-link class="dropdown-item pointer-link" to="/cashcollect/transactions-daily">Daily Statement</router-link>
                           <router-link class="dropdown-item pointer-link" to="/cashcollect/transactions-monthly">Monthly Statement</router-link>
                            <!-- <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link> -->
                           <!-- <a class="dropdown-item pointer-link" @click.prevent="reports(2)">Consolidated Statement</a> -->
                        </div>
                    </li>

              </ul>
                <ul class="navbar-nav" v-if="activeModelCode=='VIRTUAL_ACCOUNT'">
                    <li class="nav-item"  v-if="isShow('0,1,2,3')" @click.prevent="setActive('search')" :class="{ active: isActive('search') }">
                        <router-link  class="nav-link" to="/collect/search">Search</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('transactions')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/collect/transactions">Transactions</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('customers')" :class="{ active: isActive('customers') }">
                        <router-link  class="nav-link" to="/collect/customers">Customers</router-link>
                    </li>
                    <li class="nav-item" v-if="marketApi && isShow('0,1,2,3')" @click.prevent="setActive('orders')" :class="{ active: isActive('orders') }">
                        <router-link  class="nav-link" to="/order/orderlist">Orders</router-link>
                    </li>
                    <li class="nav-item"  v-if="isShow('0,30')" @click.prevent="setActive('settlements')" :class="{ active: isActive('settlements') }">
                        <router-link  class="nav-link" to="/collect/settlements">Settlements</router-link>
                    </li>

                   <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                          <a class="dropdown-item pointer-link" @click.prevent="reports(3)">Daily Statement</a>
                           <a class="dropdown-item pointer-link" @click.prevent="reports(1)">Monthly Statement</a>
                            <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link>
                           <!-- <a class="dropdown-item pointer-link" @click.prevent="reports(2)">Consolidated Statement</a> -->
                        </div>
                    </li>

                </ul>
                <ul class="navbar-nav" v-if="activeModelCode=='ONDEMAND_SETTLEMENT'">
                    <li class="nav-item" v-if="isShow('0,1,2,3')" @click.prevent="setActive('search')" :class="{ active: isActive('search') }">
                        <router-link  class="nav-link" to="/ondemand-settlement/search">Search</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('statements')" :class="{ active: isActive('statements') }">
                        <router-link  class="nav-link" to="/ondemand-settlement/statements">Statement</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,50,51,52')" @click.prevent="setActive('bulkondemandsettlements')" :class="{ active: isActive('bulkondemandsettlements') }">
                        <router-link  class="nav-link" to="/ondemand-settlement/bulkondemandsettlements">Bulk Refunds</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <router-link  class="dropdown-item" to="/ondemand-settlement/dailyreport">Daily Statement</router-link>
                          <router-link  class="dropdown-item" to="/ondemand-settlement/monthlyreport">Monthly Statement</router-link>
                          <router-link  class="dropdown-item" to="/ondemand-settlement/reportsbydaterange">Date Range Statement</router-link>
                          <router-link  class="dropdown-item" to="/ondemand-settlement/recreditsummary">Recredit Summary</router-link>
                          <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav" v-if="activeModelCode=='UPI'">
                    <li class="nav-item" v-if="upiEnablePaymentLinks && isShow('0,1,2,3')" @click.prevent="setActive('upiEnablePaymentLinks')" :class="{ active: isActive('upiEnablePaymentLinks') }">
                      <router-link  class="nav-link" to="/upi/paymentlink">Link Payments</router-link>
                    </li>
                    <li class="nav-item" v-if="upiEnableBulkPaymentLinks && isShow('0,1,2,3')" @click.prevent="setActive('upiEnableBulkPaymentLinks')" :class="{ active: isActive('upiEnableBulkPaymentLinks') }">
                      <router-link  class="nav-link" to="/upi/bulk-link-payment">Bulk Link Payments</router-link>
                    </li>
                    <li class="nav-item" v-if="upiEnableStaticLink && isShow('0,1,2,3')" @click.prevent="setActive('upiEnableStaticLink')" :class="{ active: isActive('upiEnableStaticLink') }">
                      <router-link  class="nav-link" to="/upi/payment-pages">Payment Pages</router-link>
                    </li>
                     <li class="nav-item" v-if="isShow('0,1,2,3')" @click.prevent="setActive('search')" :class="{ active: isActive('search') }">
                        <router-link  class="nav-link" to="/upi/search">Search</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('transactions')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/upi/transactions">Transactions</router-link>
                    </li>

                     <li class="nav-item" v-if="isShow('0,30')" @click.prevent="setActive('settlements')" :class="{ active: isActive('settlements') }">
                        <router-link  class="nav-link" to="/upi/settlements">Settlements</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <router-link  class="dropdown-item" to="/upi/transactions-daily">Daily Statement</router-link>
                          <router-link  class="dropdown-item" to="/upi/transactions-monthly">Monthly Statement</router-link>
                          <router-link v-if="upiEnableStaticLink" class="dropdown-item" to="/upi/payment-pages-transactions-daily">Payment Pages - Daily Statement</router-link>
                          <router-link v-if="upiEnableStaticLink" class="dropdown-item" to="/upi/payment-pages-transactions-monthly">Payment Pages - Monthly Statement</router-link>
                      <!--    <router-link  class="dropdown-item" to="/upi/validation-statement">UPI Validation Statement</router-link> -->
                          <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link>
                        </div>
                    </li>

                </ul>
                <ul class="navbar-nav" v-if="activeModelCode=='BBPS_BOU'">
                     <li class="nav-item" v-if="isShow('0,1,2,3')" @click.prevent="setActive('search')" :class="{ active: isActive('search') }">
                        <router-link  class="nav-link" to="/bbps/search">Search</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('transactions')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/bbps/transactions">Transactions</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,30')" @click.prevent="setActive('settlements')" :class="{ active: isActive('settlements') }">
                        <router-link  class="nav-link" to="/bbps/settlements">Settlements</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0') && billerTypeId==3" @click.prevent="setActive('bills')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/bbps/bills">Bills</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <router-link  class="dropdown-item" to="/bbps/transactions-daily">Daily Statement</router-link>
                          <router-link  class="dropdown-item" to="/bbps/transactions-monthly">Monthly Statement</router-link>
                          <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav" v-if="activeModelCode=='UPI_STATIC_QR'">
                     <li class="nav-item" v-if="isShow('0,1,2,3')" @click.prevent="setActive('search')" :class="{ active: isActive('search') }">
                        <router-link  class="nav-link" to="/upi-static-qr/search">Search</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('transactions')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/upi-static-qr/transactions">Transactions</router-link>
                    </li>

                     <li class="nav-item" v-if="isShow('0,30')" @click.prevent="setActive('settlements')" :class="{ active: isActive('settlements') }">
                        <router-link  class="nav-link" to="/upi-static-qr/settlements">Settlements</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <router-link  class="dropdown-item" to="/upi-static-qr/transactions-daily">Daily Statement</router-link>
                          <router-link  class="dropdown-item" to="/upi-static-qr/transactions-monthly">Monthly Statement</router-link>
                          <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link>
                        </div>
                    </li>

                </ul>
                <ul class="navbar-nav" v-if="activeModelCode=='UPI_DYNAMIC_QR'">
                     <li class="nav-item" v-if="isShow('0,1,2,3')" @click.prevent="setActive('search')" :class="{ active: isActive('search') }">
                        <router-link  class="nav-link" to="/upi-dynamic-qr/search">Search</router-link>
                    </li>
                    <li class="nav-item" v-if="isShow('0,2,3')" @click.prevent="setActive('transactions')" :class="{ active: isActive('transactions') }">
                        <router-link  class="nav-link" to="/upi-dynamic-qr/transactions">Transactions</router-link>
                    </li>

                     <li class="nav-item" v-if="isShow('0,30')" @click.prevent="setActive('settlements')" :class="{ active: isActive('settlements') }">
                        <router-link  class="nav-link" to="/upi-dynamic-qr/settlements">Settlements</router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="isShow('0,30')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-bs-toggle="dropdown">
                           Reports
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <router-link  class="dropdown-item" to="/upi-dynamic-qr/transactions-daily">Daily Statement</router-link>
                          <router-link  class="dropdown-item" to="/upi-dynamic-qr/transactions-monthly">Monthly Statement</router-link>
                          <router-link  class="dropdown-item" to="/billing/invoice-list">Billing</router-link>
                        </div>
                    </li>

                </ul>
                <ul class="navbar-nav" v-if="isShow('0,20,40')">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Settings
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item pointer-link" v-if="isShow('0,20')" @click.prevent="webhookPage()">Configurations</a>
                            <a class="dropdown-item pointer-link" v-if="isShow('0,20')" @click.prevent="tokenPage()">API Tokens</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item pointer-link" v-if="isShow('0,40')" @click.prevent="usermanagementPage()">Logins</a>
                            <div v-if="isShow('0') && isSettlementOption()" @click.prevent="getSettlementBankAccounts()" class="dropdown-divider"></div>
                            <a class="dropdown-item pointer-link" v-if="isShow('0') && isSettlementOption()" @click.prevent="getSettlementBankAccounts()">Settlement Bank Accounts</a>
                        </div>
                    </li>
                </ul>

                <ul class="navbar-nav ms-auto">

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="org-round">{{name.charAt(0).toUpperCase()}}</span>
                            {{name}}
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <label class="ps-3 mt-1 text-small"><em>Version: {{version}}</em></label><a class="border-bottom pointer-link" v-on:click="refreshPage()"> Refresh </a><br/>
                          <label v-if="accountNames.length>1" class="ps-3 mt-1"><em>Switch Account:</em></label>
                            <a class="dropdown-item pointer-link" v-for="(accountName, index) in accountNames" v-if="index!=accountIndex && accountNames.length>1" @click.prevent="switchAccount(index)"><span class="org-round">{{accountName.charAt(0).toUpperCase()}}</span>{{ accountName }}</a>
                            <div class="dropdown-divider"></div>
                            <div>
                                <p class="ps-3 mt-1"><strong>Company Name:</strong> <br> {{ companyName }}</p>
                                <div class="dropdown-divider"></div>
                                <p v-if="merchantCode" class="ps-3 mt-1"><strong>Merchant ID:</strong> <br> {{ merchantCode }}</p>
                            </div>

                            <div class="dropdown-divider"></div>

                          <!--  <router-link v-if="roleId ===100"  class="dropdown-item pointer-link" to="/logins">Manage Logins</router-link>
                            <div v-if="roleId ===100" class="dropdown-divider"></div> -->
                            <a class="dropdown-item pointer-link" @click.prevent="changePassword()">Change Login Password</a>
                            <a class="dropdown-item pointer-link" @click.prevent="change2FactorAuthentication()">2FA Authentication</a>
                            <a class="dropdown-item pointer-link" v-on:click="logout()">Logout</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
 </header>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Navbar',
  data(){
    return{
      activeModel:this.$store.state.user.activeModelCode,
      marketApi: this.$store.state.user.marketApi,
      upiEnablePaymentLinks:this.$store.state.user.upiEnablePaymentLinks,
      upiEnableStaticLink:this.$store.state.user.upiEnableStaticLink,
      billerTypeId: this.$store.state.user.billerTypeId,
      activeModelName: '',
      activeItem: '',
      cdnUrl :process.env.VUE_APP_CDN_URL+'/img/paysharp.svg',
      version:process.env.VUE_APP_VERSION,
      env:process.env.VUE_APP_ENV,
      upiEnableBulkPaymentLinks:this.$store.state.user.upiEnableBulkPaymentLinks,
      companyName: this.$store.state.user.companyName,
      merchantCode: this.$store.state.user.merchantCode
    }
  },
  mounted () { this.getModelName() },
  computed: {
    ...mapGetters([
      'roleIds',
      'name',
      'cusLabelName',
      'accountNames',
      'accountIndex',
      'activeModelCode',
      'productList',
      'policy',
      'companyName',
      'merchantCode'
    ])
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$notify({
                      title: 'Successfully logged out',
                      message: '',
                      type: 'success',
                      duration: 5000
                });
      this.$router.push(`/?redirect=${this.$route.fullPath}`)
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    logonav(){
     this.$router.push('/dashboard');
    },
    changePassword(){
      this.$router.push('/changePassword');
      this.activeItem ='';
    },
    reports(typeId){
      if(typeId === 1){
        this.$router.push('/collect/transactions-monthly');
      } else if(typeId === 2){
        this.$router.push('/collect/consolidate-monthly');
      }
      else{
         this.$router.push('/collect/transactions-daily');
      }
      this.activeItem ='';
    },

    async switchAccount(accountIndex){
      await this.$store.dispatch('user/getInfo', accountIndex);
      this.$router.push('/dashboard');
    },
    async changeModel(item){
      this.activeModel = item.productCode;
      this.activeModelName = item.productName;
      await this.$store.dispatch('user/changeModel',  item.productCode);
      this.$router.push('/dashboard');

    },
    getModelName(){
      const code = this.$store.state.user.activeModelCode;
      this.activeModelName = this.productList.find(function(e){return e.productCode == code}).productName;
    },
    isShow(valRoleIds){

     let roleExists =[];
      const roleIds = this.$store.state.user.roleIds;
      valRoleIds = valRoleIds.split(",");
      if(roleIds.includes(0)){
       return true;
      } else{
        for (let i = 0; i < roleIds.length; i++) {
            if (valRoleIds.includes(roleIds[i].toString())) {
                roleExists.push(roleIds[i]);
            }
        }

        if(roleExists.length > 0){
          return true;
        } else{
          return false;
        }
      }

    },
    isSettlementOption() {
      if (this.policy) {
        if (this.isJson(this.policy) && Object.keys(this.policy).length !== 0) {
          if (this.policy.hasOwnProperty('account') && this.policy.account.hasOwnProperty('settlementBankAccountOptions')) {
            if (this.policy.account.settlementBankAccountOptions == 1) {
              return true;
            }
            else {
              return false;
            }
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    isJson(item) {
        item = typeof item !== "string" ? JSON.stringify(item) : item;
        try {
            item = JSON.parse(item);
        } catch (e) {
            return false;
        }

        if (typeof item === "object" && item !== null) {
            return true;
        }

        return false;
    },
    usermanagementPage(){
      this.$router.push('/usermanagement');
    },
    webhookPage(){
      this.$router.push('/settings/product-configurations');
    },
    tokenPage(){
      this.$router.push('/settings/manage-tokens');
    },
    change2FactorAuthentication(){
      this.$router.push('/2factor');
      this.activeItem ='';
    },
    getSettlementBankAccounts(){
      this.$router.push('/settlement-bank-accounts');
      this.activeItem ='';
    },
    refreshPage() {
        window.location.reload();
    }

  }
};
</script>
<style>
.navbar {
    padding: .3rem 1rem !important;
}
.nav-light .navbar-nav .nav-link {
    color: #2d3835;
}

.navbar {

}
</style>
